import { render, staticRenderFns } from "./VendorSelect.vue?vue&type=template&id=bfdbced6&scoped=true&"
import script from "./VendorSelect.vue?vue&type=script&lang=js&"
export * from "./VendorSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdbced6",
  null
  
)

export default component.exports